import { Model } from 'pinia-orm'
import { Num, Str } from 'pinia-orm/decorators'

export default class RefereeRole extends Model {
    static entity = 'referee-roles'

    static readonly MainReferee = 1

    static readonly Referee = 2

    static readonly JuryChairman = 3

    static readonly Judge = 4

    static readonly Umpire = 5

    static readonly ChiefUmpire = 6

    static readonly MainCourseReferee = 10

    @Num(0, { notNullable: true })
    declare id: number
    @Str('', { notNullable: true })
    declare role: string
    @Str(null)
    declare shortcut: string
    @Num(0)
    declare points: number

    get order(): number {
        return this.isMainReferee
            ? 100
            : (this.isMainCourseReferee
                ? 70
                : (this.isJuryChairman
                    ? 50
                    : (this.isChiefUmpire ? 30 : 1)))
    }

    get isMainReferee(): boolean {
        return this.id === RefereeRole.MainReferee
    }

    get isMainCourseReferee(): boolean {
        return this.id === RefereeRole.MainCourseReferee
    }

    get isChiefUmpire(): boolean {
        return this.id === RefereeRole.ChiefUmpire
    }

    get isJuryChairman(): boolean {
        return this.id === RefereeRole.JuryChairman
    }

    get isJudge(): boolean {
        return this.id === RefereeRole.Judge
    }

    get isUmpire(): boolean {
        return this.id === RefereeRole.Umpire
    }

    get isReferee(): boolean {
        return this.id === RefereeRole.Referee
    }

    get internationalName(): string | null {
        if (this.isMainReferee)
            return 'Principal Race Officer'

        if (this.isMainCourseReferee)
            return 'Race Officer'

        if (this.isChiefUmpire)
            return 'Chief Umpire'

        if (this.isJuryChairman)
            return 'Chief Judge'

        if (this.isReferee)
            return 'Race Committee'

        if (this.isJudge)
            return 'Judge'

        if (this.isUmpire)
            return 'Umpire'

        return null
    }

    static piniaOptions = {
        persist: true,
    }
}
